import React from 'react';
import { observer } from 'mobx-react';
import { classes } from '~utils/ClassNames';
import { Caption } from '@estee/elc-typography';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';

const translationsList = ['discountCannotCombinedOtherOffers'];

const replenismentDisclaimerClass = classes('cart-auto-replenishment-disclaimer');

export const ReplenishmentDisclaimer = observer(() => {
    const { discountCannotCombinedOtherOffers } = useTranslation(translationsList);

    return (
        <Caption className={replenismentDisclaimerClass}>
            {discountCannotCombinedOtherOffers}
        </Caption>
    );
});
